import { IMAGE_CONFIG } from '@angular/common';
import { ApplicationConfig } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
// import { provideClientHydration } from '@angular/platform-browser';
import {
  RouteReuseStrategy,
  provideRouter,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling
} from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BlockScrollStrategy, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { HighlightOptions, HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { provideHotToastConfig } from '@ngxpert/hot-toast';
import { provideTippyConfig } from '@ngneat/helipopper';

import { RouteReusableStrategy } from '@core/common';
import { ApiRequestInterceptor } from '@core/http';
import { provideSounds } from '@core/sounds';
import { provideMeta } from '@core/meta';
import { provideAssetsDir } from '@core/common/tokens';

import { routes } from './app.routes';
import { tippyVariations } from './tippy-variations';
import { SOUNDS_LIST } from './sounds-list';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    // provideClientHydration(),
    provideRouter(
      routes,
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      }),
      withComponentInputBinding()
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideTippyConfig({
      defaultVariation: 'tooltip',
      variations: tippyVariations
    }),
    provideMeta({
      description: $localize`:@@meta.description:CSFAIL предлагает непревзойденный опыт Crash, Jackpot, Wheel, Double,
      Crazy Wheel CS:GO/CS2. Ежедневные раздачи, промокоды. Пополнение картами, скинами, usdt, ton, btc.`,
      sitename: $localize`:@@meta.sitename_short:CSFAIL`,
      defaultTitle: $localize`:@@meta.sitename:CSFAIL — Лидер среди CS2/CS:GO краш сайтов`
    }),
    provideAssetsDir(),
    provideSounds(SOUNDS_LIST),
    provideHotToastConfig(),
    {
      provide: RouteReuseStrategy,
      useClass: RouteReusableStrategy
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiRequestInterceptor,
      multi: true
    },
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: <HighlightOptions>{
        coreLibraryLoader: async () => import('highlight.js/lib/core'),
        lineNumbers: true,
        languages: {
          javascript: async () =>
            import('highlight.js/lib/languages/javascript')
        }
      }
    },
    {
      provide: BlockScrollStrategy,
      useFactory: (scrollStrategyOptions: ScrollStrategyOptions) =>
        scrollStrategyOptions.block(),
      deps: [ScrollStrategyOptions]
    },
    {
      provide: IMAGE_CONFIG,
      useValue: {
        disableImageSizeWarning: true,
        disableImageLazyLoadWarning: true
      }
    }
  ]
};
